<template>
	<tbody v-if="!!tbody && !!tbody.length" :data-page="current" v-model="items">
		<tr
			v-for="(item, row_index) in items"
			:key="row_index"
			:ref="'tbody_tr_' + row_index"
			:class="{
				editable: !!editable && selectedIndex.indexOf(row_index) != -1 ? true : false,
				//selected: !!selectable && selectedIndex.indexOf(item[selectable]) != -1 ? true : false,
			}"
		>
			<td v-if="!!numbered">{{ min + row_index + 1 }}</td>
			<td v-if="!!selectable" class="form-td">
				<div :style="{ display: 'flex' }">
					<form-checkbox
						:toggle="false"
						name="row_selected[]"
						:options="[{ value: item[selectable], label: '' }]"
						:values="selectedIndex"
						@change="() => clickedRow(item[selectable])"
					></form-checkbox>
				</div>
			</td>
			<td v-if="!!draggable" class="icon">
				<div :style="{ display: 'flex', justifyContent: 'space-between' }">
					<btn
						type="primary"
						light
						table
						label=""
						:action="() => {}"
						:icon="['far', 'chevron-down']"
						v-if="row_index + 1 < items.length"
					></btn>
					<btn
						type="primary"
						light
						table
						label=""
						:action="() => {}"
						:icon="['far', 'chevron-up']"
						v-if="row_index > 0"
					></btn>
				</div>
			</td>

			<datatable-body-cell
				v-for="(value, col_index) in thead"
				:key="row_index + '_' + col_index"
				:rowIndex="row_index"
				:colIndex="col_index"
				:row="item"
				:col="value"
				:sorted="isSorted(col_index)"
				:sortDirection="isSortedDirection(col_index)"
				:customRender="returnCustomRender(col_index)"
				:editable="!!editable && selectedIndex.indexOf(row_index) != -1 ? true : false"
			></datatable-body-cell>

			<td v-if="!!editable && selectedIndex.indexOf(row_index) != -1" class="actions">
				<div :style="{ display: 'flex' }">
					<btn
						:action="() => submitFormRow(row_index)"
						type="success"
						light
						table
						label="Salva"
						:icon="['far', 'check']"
					/>
					<btn
						:action="() => unselectRow(row_index)"
						type="danger"
						light
						table
						label="Annulla"
						:icon="['far', 'times']"
					/>
				</div>
			</td>

			<datatable-row-actions
				v-else-if="!!showActions && !selectedIndex.length"
				:actions="getActions(item)"
				:row="item"
				:editRefmodal="editRefmodal"
				:row_index="row_index"
				@refreshTable="refreshTable"
			></datatable-row-actions>
			<td
				v-else-if="(!!editable || !!selectable) && selectedIndex.indexOf(row_index) == -1"
			></td>
			<td v-else-if="!!selectable && selectedIndex.indexOf(row_index) != -1"></td>
		</tr>
	</tbody>
	<tbody v-else>
		<tr>
			<td :colspan="getColsNumber">
				<datatable-loader v-if="!!loading"></datatable-loader>
				<i v-else>Nessun record presente...</i>
			</td>
		</tr>
	</tbody>
</template>

<script>
export default {
	data: () => ({
		items: [],
		min: 0,
		selectedUrls: {},
		selectedIndex: [],
	}),
	props: {
		loading: {
			type: Boolean,
			default: false,
			required: false,
		},
		thead: {
			type: Array,
			default: () => [],
			required: true,
		},
		tbody: {
			type: Array,
			default: () => [],
			required: true,
		},
		length: {
			type: Number,
			default: 1,
			required: true,
		},
		current: {
			type: Number,
			default: 1,
			required: true,
		},
		orderingEnabled: {
			type: Boolean,
			default: true,
			required: true,
		},
		pagingEnabled: {
			type: Boolean,
			default: true,
			required: true,
		},
		ordering: {
			type: Array,
			default: () => [],
			required: true,
		},
		showActions: {
			type: Boolean,
			default: true,
			required: true,
		},
		fieldActions: {
			type: String,
			default: 'actions',
			required: false,
		},
		editRefmodal: {
			type: String,
			default: '',
			required: false,
		},
		customRender: {
			type: Array,
			default: () => [],
			required: true,
		},
		editable: {
			type: Boolean,
			default: false,
			required: false,
		},
		selectable: {
			type: String,
			default: '',
			required: false,
		},
		draggable: {
			type: String,
			default: '',
			required: false,
		},
		numbered: {
			type: String,
			default: '',
			required: false,
		},
	},
	computed: {
		getColsNumber: function () {
			let num = this.thead.length

			if (!!this.showActions || !!this.editable) num++
			if (!!this.selectable) num++
			if (!!this.draggable) num++

			return num
		},
	},
	methods: {
		clickedRow: function (index) {
			if (!!this.selectable) {
				if (this.selectedIndex.indexOf(index) != -1) {
					this.unselectRow(index)
				} else {
					this.selectedIndex.push(index)
				}
			}
			console.log(this.selectedIndex)
		},
		selectEditRow: function (urlupdate, index) {
			this.selectedIndex.push(index)
			this.selectedUrls[index] = urlupdate
		},
		unselectRow: function (index) {
			let indexArr = this.selectedIndex.indexOf(index)
			if (indexArr != -1) {
				this.selectedIndex.splice(indexArr, 1)
				if (!!this.selectedUrls[index]) delete this.selectedUrls[index]
			}
		},
		submitFormRow: function (index) {
			if (!this.selectedUrls[index]) return false

			return this.$root.requestPatch(
				this,
				this.selectedUrls[index],
				this.$root.getParamsFromDiv(this.$refs['tbody_tr_' + index][0]),
				function (data) {
					this.submitFormCallback(index, data)
				}
			)
		},
		submitFormCallback: function (index, data) {
			this.refreshTable()
			this.unselectRow(index)
		},
		returnCustomRender: function (indexCol) {
			for (var i = 0; i < this.customRender.length; i++) {
				let element = this.customRender[i]

				if (
					typeof element.index !== 'undefined' &&
					element.index === indexCol &&
					typeof element.render !== 'undefined'
				)
					return element.render
			}

			return null
		},
		isSorted: function (index) {
			return !!this.ordering.find((o) => o.index === index)
		},
		isSortedDirection: function (index) {
			let element = this.ordering.find((o) => o.index === index)
			if (!!element) return element.sort
			return ''
		},
		setMin: function () {
			let oldMin = this.min
			this.min = (this.current - 1) * this.length

			if (oldMin != this.min) {
				this.selectedUrls = {}
				this.selectedIndex = []
			}
		},
		setItems: function () {
			// let items = []
			//
			// for (var i = 0; i < this.tbody.length; i++) {
			//     items.push(this.tbody[i])
			// }
			if (!!this.tbody) {
				this.items = this.tbody.map((t) => t)
			}
		},
		limitItems: function () {
			if (!this.pagingEnabled) return

			let end = this.length * this.current
			if (end > this.items.length) end = this.items.length

			this.items = this.items.slice(this.min, end)
		},
		sortBy: function (field, type, format, reverse) {
			if (type.toUpperCase() == 'DATETIME') {
				let key = function (x) {
					if (typeof x[field] === 'undefined') return ''
					return !!x[field] ? moment(x[field], !!format ? format : 'YYYY-MM-DD') : 0
				}
			} else {
				var key = function (x) {
					if (typeof x[field] === 'undefined') return ''

					if (!x[field]) return ''
					if (isNaN(x[field])) return x[field].toUpperCase()
					else if (x[field] % 1 === 0) return parseInt(x[field])
					else return parseFloat(x[field])
				}
			}

			return function (a, b) {
				var A = key(a),
					B = key(b)

				if (reverse) return A < B ? 1 : A > B ? -1 : 0
				else return A < B ? -1 : A > B ? 1 : 0
			}
		},
		orderItems: function () {
			if (!this.orderingEnabled) return

			let items = this.items

			for (var i = 0; i < this.ordering.length; i++) {
				let element = this.ordering[i]
				let thead = this.thead[element.index]

				if (!thead.orderable || !thead.data) continue

				items.sort(
					this.sortBy(
						thead.data,
						thead.type,
						thead.typeFormat,
						element.sort.toUpperCase() !== 'ASC'
					)
				)
			}

			this.items = items
		},
		orderDraggableItems: function () {
			if (!this.draggable) return

			let items = this.items

			items.sort(this.sortBy(this.draggable, 'number', '', false))

			this.items = items
		},
		init: function () {
			this.setMin()
			this.setItems()
			this.orderDraggableItems()
			this.orderItems()
			this.limitItems()
		},
		refreshTable: function () {
			this.$parent.refreshTable()
		},
		getActions: function (item) {
			return !!item[this.fieldActions] ? item[this.fieldActions] : []
		},
	},
	created: function () {
		this.init()
	},
	beforeUpdate: async function () {
		this.init()
	},
}
</script>
